import * as React from "react";
import { forwardRef } from "react";
const SvgLt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 900, height: 200, fill: "#FDB913" }), /* @__PURE__ */ React.createElement("rect", { width: 900, height: 200, y: 200, fill: "#006A44" }), /* @__PURE__ */ React.createElement("rect", { width: 900, height: 200, y: 400, fill: "#C1272D" }));
const ForwardRef = forwardRef(SvgLt);
export { ForwardRef as ReactComponent };
